import { useT } from "@/app/hooks/useT";
import type { PaymentTransaction } from "@/app/types/payments";
import { MaskedAccountField } from "@/app/utils/MaskedAccountField";
import { SvgIcon } from "@progress/kendo-react-common";
import { chevronDownIcon, chevronUpIcon } from "@progress/kendo-svg-icons";
import { useState } from "react";

interface TransferToProp {
  transaction: PaymentTransaction;
}
export const TransferTo = ({ transaction }: TransferToProp) => {
  const t = useT();
  const [isTransferToOpen, setIsTransferToOpen] = useState<boolean>(true);

  return (
    <div className="gx-transaction-detail-card ">
      <button
        className="gx-transaction-detail-card-header"
        onClick={() => setIsTransferToOpen(!isTransferToOpen)}
      >
        <h2 className="gx-transaction-detail-card-title gx-h3-b">{t("transfer_to")}</h2>
        <SvgIcon
          icon={isTransferToOpen ? chevronUpIcon : chevronDownIcon}
          size="small"
        />
      </button>
      {isTransferToOpen && (
        <div className="gx-transaction-detail-card-body">
          <MaskedAccountField
            label="Account"
            accountNumber={transaction?.beneAccountNo || "---"}
          />

          <div className="gx-transaction-detail-row">
            <span className="gx-t-lable">{t("beneficiary_name")}</span>
            <span className="gx-t-value">
              {transaction?.beneAccountName || "---"}
            </span>
          </div>
          <div className="gx-row">
            <span className="gx-t-lable">{t("beneficiary_address")}</span>
            <span className="gx-t-value-break">
              {[transaction?.beneAddressLine1].filter(Boolean).join(", ") ||
                "---"}
            </span>
          </div>
          <div className="gx-row">
            <span className="gx-t-lable">{t("beneficiary_bank_country")}</span>
            <span className="gx-t-value-break">
              {transaction?.beneBankCountryName || "---"}
            </span>
          </div>
          <div className="gx-row">
            <span className="gx-t-lable">{t("beneficiary_bank_name")}</span>
            <span className="gx-t-value">
              {transaction?.beneBankName || "---"}
            </span>
          </div>
          <div className="gx-row">
            <span className="gx-t-lable ">{t("beneficiary_bank_address")}</span>
            <span className="gx-t-value-break">
              {[transaction?.beneBankAddressLine1].filter(Boolean).join(", ") ||
                "---"}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};
